import { useEffect, useState } from 'react';
import { api, type PaymentInfo } from '../api';

function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
}

function statusBadge(status: string): { cls: string; label: string } {
  if (status === 'SUCCEEDED') return { cls: 'ok', label: 'оплачен' };
  if (status === 'FAILED') return { cls: 'err', label: 'ошибка' };
  return { cls: 'warn', label: 'в обработке' };
}

export function PaymentsPage() {
  const [items, setItems] = useState<PaymentInfo[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.payments().then((d) => setItems(d.payments)).catch((e) => setError(e instanceof Error ? e.message : 'Ошибка'));
  }, []);

  if (error) return <div className="container"><div className="error">{error}</div></div>;
  if (!items) return <div className="container">Загрузка…</div>;

  return (
    <div className="container">
      <h1>Платежи</h1>
      <div className="card">
        {items.length === 0 ? (
          <p className="muted">Платежей пока нет.</p>
        ) : (
          <div className="pay-list">
            {items.map((p) => {
              const badge = statusBadge(p.status);
              return (
                <div key={p.id} className="pay-row">
                  <span className="pay-date">{formatDate(p.paidAt ?? p.createdAt)}</span>
                  <span className="pay-plan">{p.planTitle ?? p.planCode ?? '—'}</span>
                  <span className="pay-amount">{p.amountRub} ₽</span>
                  <span className={`badge ${badge.cls} pay-status`}>{badge.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
